module.exports = __webpack_public_path__ + "img/inject-panel.c542d3cb.svg";